import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Apply saved theme as early as possible so the first paint uses the
// correct palette (no flash of default colors).
import "@/lib/themeSwitcher";
import App from "@/App";

// Suppress ResizeObserver loop warning (harmless, from Recharts/Radix UI)
const origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && msg.includes('ResizeObserver')) return true;
  return origError ? origError(msg, ...args) : false;
};
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver')) { e.stopImmediatePropagation(); e.preventDefault(); }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Register PWA Service Worker. If a NEW version activates while the page is
// open, the SW posts `SW_ACTIVATED` and we soft-reload once so users always
// run the freshly-deployed bundle (this fixes "white page after deploy"
// caused by stale shells referring to dead JS hashes).
if ('serviceWorker' in navigator) {
  let _alreadyReloaded = false;
  navigator.serviceWorker.addEventListener('message', (e) => {
    if (e.data && e.data.type === 'SW_ACTIVATED' && !_alreadyReloaded) {
      _alreadyReloaded = true;
      // Defer slightly so any in-flight redux/zustand state is flushed.
      setTimeout(() => window.location.reload(), 200);
    }
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // Periodically poll for updates so long-lived tabs pick up new builds.
        setInterval(() => { try { reg.update(); } catch (_) {} }, 60 * 60 * 1000);
        if (reg.waiting) {
          // A new SW is already waiting → tell it to take over.
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
              newSW.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {});
  });
}
